import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Form } from 'react-bootstrap';
import { getUserInfo } from './functions/userInfo';
import SessionFun from './functions/sessionFun';
import {environment} from './functions/environment';

var downReq = {};
function Equipment360() {
  let userObj = getUserInfo();
  let [sessOut, setSessOut] = useState(false);
  let [equipment, setEquipment] = useState([]);
  let [site, setSite] = useState([]);
  let [downStart, setDownStart] = useState(false);
  let [equipInfo, setEquipInfo] = useState({
    "Vehicle and Operator Details": {
      "Type": "NA",
      "Zone": "NA",
      "Operator Name": "NA",
      "Operator License Validity": "NA"
    },
    "Utilization": {
      "Today": 0,
      "MTD": 0,
      "YTD": 0
    },
    "YTD Fuel Consumption Pattern": {
      "Current Fuel Level": 0,
      "Hours Operated": 0,
      "Fuel Consumed": 0,
      "Fuel Consumption/Hour": 0
    },
    "YTD Breakdowns": {
      "# Breakdowns": 0
    },
    "YTD Service Requests": {
      "Open SR": 0,
      "Closed SR": 0
    },
    "YTD Impacts": {
      "Total Impacts": 0,
      "High Impacts": 0
    },
    "Periodic Service Details": {
      "Service Status": "NA"
    },
    "YTD Incident Summary": {
      "# Incidents": 0
    },
    "Important Parameters": {
      "Temp": {
        "Current": 0,
        "Max": 0,
        "Avg": 0
      },
      "Pressure": {
        "Current": 0,
        "Max": 0,
        "Avg": 0
      },
      "Voltage": {
        "Current": 0,
        "Max": 0,
        "Avg": 0
      }
    }
  });

  let [isEquip, setisEquip] = useState(false)
  const [download, setDownload] = useState(false)
  let assetIDStr = "";

  useEffect(() => {
    let abortController = new AbortController();
    getSiteByAccID(userObj.accountID);
    return () => {
      abortController.abort();
    }
  }, [])

  function getSiteByAccID(accID) {
    fetch(environment.baseUrl + "getSiteByUserAccount", {
      method: "GET",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      }
    }).then((result) => {
      result.json().then(res => {
        if (res.code == 200) {
          setSite(res.data.result.siteList);
        }
        else if (res.code == 401) {
          setSessOut(true);
        }
        else {
          setSite([]);
        }
      })
    })
  }

  function getEquipmentBySite(e) {
    setEquipInfo({
      "Vehicle and Operator Details": {
        "Type": "NA",
        "Zone": "NA",
        "Operator Name": "NA",
        "Operator License Validity": "NA"
      },
      "Utilization": {
        "Today": 0,
        "MTD": 0,
        "YTD": 0
      },
      "YTD Fuel Consumption Pattern": {
        "Current Fuel Level": 0,
        "Hours Operated": 0,
        "Fuel Consumed": 0,
        "Fuel Consumption/Hour": 0
      },
      "YTD Breakdowns": {
        "# Breakdowns": 0
      },
      "YTD Service Requests": {
        "Open SR": 0,
        "Closed SR": 0
      },
      "YTD Impacts": {
        "Total Impacts": 0,
        "High Impacts": 0
      },
      "Periodic Service Details": {
        "Service Status": "NA"
      },
      "YTD Incident Summary": {
        "# Incidents": 0
      },
      "Important Parameters": {
        "Temp": {
          "Current": 0,
          "Max": 0,
          "Avg": 0
        },
        "Pressure": {
          "Current": 0,
          "Max": 0,
          "Avg": 0
        },
        "Voltage": {
          "Current": 0,
          "Max": 0,
          "Avg": 0
        }
      }
    })

    setEquipment([])
    setisEquip(false);
    fetch(environment.baseUrl + "getEquipmentBySite?", {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      },
      body: JSON.stringify(
        {
          siteID: e.target.value
        })
    }).then((result) => {
      result.json().then(res => {
        if (res.code == 200) {
          setEquipment(res.data.result)
        }
        else if (res.code == 401) {
          setSessOut(true);
        }
        else {
          setEquipment([]);
        }
      })
    })
  }

  // GET Equipment Info
  function getEquipmentInfo(e) {
    fetch(environment.baseUrl + "equipment360", {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      },
      body: JSON.stringify(
        {
          equipmentID: e.target.value
        })
    }).then((result) => {
      result.json().then(res => {
        if (res.code == 200) {
          setEquipInfo(res.data.result.equipment360[0]);
          let data360 = res.data.result.equipment360[0];
          if (data360.length != 0) {
            setisEquip(true);
          }
          setDownload(true);
          downReq =
          {
            "equipment360": {
              "assetID": e.target.value,
              "VehicleAndOperatorDetails": {
                "Type": data360['Vehicle and Operator Details'].Type,
                "Zone": data360['Vehicle and Operator Details'].Zone,
                "CoverageDate": data360['Vehicle and Operator Details']['Coverage Date']?data360['Vehicle and Operator Details']['Coverage Date'].slice(0, 10) : "NA",
                "WarrantyDate": data360['Vehicle and Operator Details']['Warranty Date']?data360['Vehicle and Operator Details']['Warranty Date'].slice(0, 10) : "NA"
              },
              "Utilization": {
                "Today": data360.Utilization.Today,
                "MTD": data360.Utilization.MTD,
                "YTD": data360.Utilization.YTD
              },
              "YTDFuelConsumptionPattern": {
                "CurrentFuelLevel": data360['YTD Fuel Consumption Pattern']['Current Fuel Level'],
                "HoursOperated": data360['YTD Fuel Consumption Pattern']['Hours Operated'],
                "FuelConsumed": data360['YTD Fuel Consumption Pattern']['Fuel Consumed'],
                "FuelConsumption/Hour": data360['YTD Fuel Consumption Pattern']['Fuel Consumption/Hour']
              },
              "YTDBreakdowns": {
                "#Breakdowns": data360['YTD Breakdowns']['# Breakdowns']
              },
              "YTDServiceRequests": {
                "OpenSR": data360['YTD Service Requests']['Open SR'],
                "ClosedSR": data360['YTD Service Requests']['Closed SR']
              },
              "YTDImpacts": {
                "TotalImpacts": data360['YTD Impacts']['Total Impacts'],
                "HighImpacts": data360['YTD Impacts']['High Impacts']
              },
              "PeriodicServiceDetails": {
                "ServiceStatus": data360['Periodic Service Details']['Service Status']
              },
              "YTDIncidentSummary": {
                "#Incidents": data360['YTD Incident Summary']['# Incidents']
              },
              "ImportantParameters": {
                "Temp": {
                  "Current": data360['Important Parameters'].Temp.Current,
                  "Max": data360['Important Parameters'].Temp.Max,
                  "Avg": data360['Important Parameters'].Temp.Avg
                },
                "Pressure": {
                  "Current": data360['Important Parameters'].Pressure.Current,
                  "Max": data360['Important Parameters'].Pressure.Max,
                  "Avg": data360['Important Parameters'].Pressure.Avg
                },
                "Voltage": {
                  "Current": data360['Important Parameters'].Voltage.Current,
                  "Max": data360['Important Parameters'].Voltage.Max,
                  "Avg": data360['Important Parameters'].Voltage.Avg
                }
              }
            }
          }

        }
        else if (res.code == 401) {
          setSessOut(true);
        }
      })
    })
  }
  function downloadReport() {
    let ID = downReq.equipment360.assetID;
    setDownStart(true);
    fetch(environment.baseUrl + "downloadEquipment", {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      },
      body: JSON.stringify(downReq)
    }).then((result) => {
      // 1. Convert the data into 'blob'
      result.blob().then(blob => {
        // 2. Create blob link to download
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${ID}.pdf`);
        // 3. Append to html page
        document.body.appendChild(link);
        // 4. Force download
        link.click();
        // 5. Clean up and remove the link
        link.parentNode.removeChild(link);

        setDownStart(false);
      })
    })
  }


  return (
    <div className='main-container'  >
      <SessionFun show={sessOut}></SessionFun>
      <h4 className='main-heading'>Equipment 360</h4>
      <p className='short-link'><Link to='/'>Home&nbsp;<i className='fa fa-angle-right'></i></Link>&nbsp; Equipment 360</p>
      <div id="pagetodownload">
        <div className="row card-box">
          <div className="col-sm-6">
            <Form.Group className="my-3" >
              <Form.Label>Site</Form.Label>
              <Form.Select className='textbox-back' aria-label="Default select example" onChange={getEquipmentBySite}>
                <option value="">Select Site</option>
                {
                  site.map((item, index) =>
                    <option value={item.siteID} key={index} >{item.siteName}</option>
                  )
                }
              </Form.Select>
            </Form.Group>
          </div>
          <div className="col-sm-6">
            <Form.Group className="my-3" >
              <Form.Label>Equipment</Form.Label>
              <Form.Select className='textbox-back' aria-label="Default select example" onChange={getEquipmentInfo}>
                <option value="">Select Equipment</option>
                {
                  equipment.map((item, index) => {
                    assetIDStr = item.assetID
                    return (
                      <option value={assetIDStr} key={index} >{assetIDStr}</option>
                    )
                  }
                  )
                }
              </Form.Select>
            </Form.Group>
          </div>
        </div>
        <div className={isEquip ? "row mt-3" : "d-none"}  >
          <div className="col-sm-9 left-col">
            <div className="row">
              <div className="col-sm-7 left-col">
                <div className="card-box-block" style={{ height: "138px" }}>
                  <h6 className='cardtitle'>Vehicle Details</h6>
                  <div className="row">
                    <div className="col-sm-6 left-col">
                      <p className="card-sub-text">Type</p>
                      <p className="card-sub-text">Geofence</p>
                      <p className="card-sub-text">Under Warranty Till Date</p>
                      <p className="card-sub-text">Under Coverage Till Date</p>
                    </div>
                    <div className="col-sm-6 left-col">
                      <p className="card-sub-text"><b> : {equipInfo["Vehicle and Operator Details"].Type !== 'undefined' ? equipInfo["Vehicle and Operator Details"].Type : "NA"}</b></p>
                      <p className="card-sub-text"><b> : {equipInfo["Vehicle and Operator Details"].Zone ? equipInfo["Vehicle and Operator Details"].Zone : "NA"}</b></p>
                      <p className="card-sub-text"><b> : {equipInfo["Vehicle and Operator Details"]["Warranty Date"] ? equipInfo["Vehicle and Operator Details"]["Warranty Date"].slice(0, 10) : "NA"}</b></p>
                      <p className="card-sub-text"><b> : {equipInfo["Vehicle and Operator Details"]["Coverage Date"] ? equipInfo["Vehicle and Operator Details"]["Coverage Date"].slice(0, 10) : "NA"}</b></p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-sm-5 card-box-block">
                <h6 className='cardtitle'>Utilization</h6>
                <div className="row">
                  <div className="col-sm-6 left-col">
                    <p className="card-sub-text">Today</p>
                    <p className="card-sub-text">MTD</p>
                    <p className="card-sub-text">YTD</p>
                  </div>
                  <div className="col-sm-6 left-col">
                    <p className="card-sub-text"><b> : {equipInfo['Utilization']['Today']}%</b></p>
                    <p className="card-sub-text"><b> : {equipInfo['Utilization']['MTD']}%</b></p>
                    <p className="card-sub-text"><b> : {equipInfo['Utilization']['YTD']}%</b></p>
                  </div>
                </div>
              </div>
            </div>
            <div className="row mt-3">
              <div className="col-sm-7 left-col">
                <div className="card-box-block">
                  <h6 className='cardtitle'> YTD Fuel Consumption Pattern</h6>
                  <div className="row">
                    <div className="col-sm-6 left-col">
                      <p className="card-sub-text">Present Fuel Level (%)</p>
                      <p className="card-sub-text">Fuel Consumed (Litres)</p>
                      <p className="card-sub-text">Fuel Consumed/Hour (Litres)</p>
                      <p className="card-sub-text">Hour Operated</p>
                    </div>
                    <div className="col-sm-6 left-col">
                      <p className="card-sub-text"><b> : {equipInfo['YTD Fuel Consumption Pattern']['Current Fuel Level']}</b></p>
                      <p className="card-sub-text"><b> : {equipInfo['YTD Fuel Consumption Pattern']['Fuel Consumed']}</b></p>
                      <p className="card-sub-text"><b> : {equipInfo['YTD Fuel Consumption Pattern']['Fuel Consumption/Hour']}</b></p>
                      <p className="card-sub-text"><b> : {equipInfo['YTD Fuel Consumption Pattern']['Hours Operated']}</b></p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-sm-5 card-box-block">
                <h6 className='cardtitle'>YTD Breakdowns</h6>
                <div className="row">
                  <div className="col-sm-6 left-col">
                    <p className="card-sub-text">Breakdowns</p>
                  </div>
                  <div className="col-sm-6 left-col">
                    <p className="card-sub-text"><b> : {equipInfo['YTD Breakdowns']['# Breakdowns']}</b></p>
                  </div>
                </div>
              </div>
            </div>
            <div className="row mt-3 card-box-block">
              <h6 className='cardtitle'>Important Parameters</h6>
              <table className="table">
                <thead className='table-secondary'>
                  <tr>
                    <th scope="col">Parameters</th>
                    <th scope="col">Present</th>
                    <th scope="col">Max</th>
                    <th scope="col">Avg</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th scope="row">Temp</th>
                    <td>{equipInfo['Important Parameters'].Temp.Current}</td>
                    <td>{equipInfo['Important Parameters'].Temp.Max}</td>
                    <td>{equipInfo['Important Parameters'].Temp.Avg}</td>
                  </tr>
                  <tr>
                    <th scope="row">Pressure</th>
                    <td>{equipInfo['Important Parameters'].Pressure.Current}</td>
                    <td>{equipInfo['Important Parameters'].Pressure.Max}</td>
                    <td>{equipInfo['Important Parameters'].Pressure.Avg}</td>
                  </tr>
                  <tr>
                    <th scope="row">Voltage</th>
                    <td>{equipInfo['Important Parameters'].Voltage.Current}</td>
                    <td>{equipInfo['Important Parameters'].Voltage.Max}</td>
                    <td>{equipInfo['Important Parameters'].Voltage.Avg}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="col-sm-3 card-box-block">
            <h6 className='cardtitle'>YTD Service Requests</h6>
            <p className='card-sub-text'>Open SR <span className='float-right'><b> : {equipInfo['YTD Service Requests']['Open SR']}</b></span></p>
            <p className='card-sub-text'>Close SR <span className='float-right'><b> : {equipInfo['YTD Service Requests']['Closed SR']} </b></span></p>

            <h6 className='mt-4 cardtitle'>YTD Impacts</h6>
            <p className='card-sub-text'>Total Impacts<span className='float-right'><b> : {equipInfo['YTD Impacts']['Total Impacts']}</b></span></p>
            <p className='card-sub-text'>Critical  Impacts<span className='float-right'><b> : {equipInfo['YTD Impacts']['High Impacts']}</b></span></p>

            <h6 className='mt-4 cardtitle'>Periodic Service Details</h6>
            <p className='card-sub-text'>Service Status <span className='float-right'><b> : {equipInfo['Periodic Service Details']['Service Status']}</b></span></p>

            <h6 className='mt-4 cardtitle'>YTD Incident Summary</h6>
            <p className='card-sub-text'>Incidents <span className='float-right'><b> : {equipInfo['YTD Incident Summary']['# Incidents']} </b></span></p>
          </div>

        </div>
      </div>

      <div className={isEquip ? "row justify-content-end mt-3" : "d-none"}>
        {
          downStart ?
            <button className="add-btn lg-btn btn-save" type="button" disabled>
              <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              Downloading...
            </button>
          :
          <button className='add-btn btn-save  confirm-btn' onClick={downloadReport}>Download</button>
        }
        
      </div>
    </div>
  )
}

export default Equipment360
